import React from 'react';
import choxoso from "../../assets/images/choxoso.gif";
import tructiepxoso from "../../assets/images/tructiepxoso.gif";
import ok_daxosoxong from "../../assets/images/ok_daxosoxong.png";
import LookUpLotteryResults from "./LookUpLotteryResults";

const LotteryResultToday = () => {

    return (
        <div>
            <div className="modulesLR moduleBrown">
                <div style={{display: "none"}}>Kết quả xổ số Hôm Nay</div>
                <div id="ketquaxosohomnay">
                    <div className="title-l">
                        <div className="title-r" style={{position: "relative"}}>
                            <a className="next-day" href="/">
                            </a>
                            <h1 style={{textAlign: "center"}}>Kết quả xổ số
                                Hôm Nay<small>Thứ tư - Ngày</small>
                            </h1>
                        </div>
                    </div>

                    <div className="body-l">
                        <div className="body-r">
                            <ul className="menu menulichxoso ">
                                <li><a className="hottoday_mien"
                                       href="/"
                                       title="Kết quả xổ Số Miền Nam"><strong>Kết
                                    quả xổ Số Miền Nam</strong></a>
                                    <ul>
                                        <li>
                                            <a href="/"
                                               title="Kết quả xổ Số Cần Thơ"><span
                                                className="icon wait">Kết quả xổ Số Cần Thơ</span></a>
                                        </li>

                                        <li>
                                            <a href="/"
                                               title="Kết quả xổ Số Đồng Nai"><span
                                                className="icon wait">Kết quả xổ Số Đồng Nai</span></a>
                                        </li>

                                        <li>
                                            <a href="/"
                                               title="Kết quả xổ Số Sóc Trăng"><span
                                                className="icon wait">Kết quả xổ Số Sóc Trăng</span></a>
                                        </li>

                                    </ul>
                                </li>
                                <li><a className="hottoday_mien"
                                       href="/"
                                       title="Kết quả xổ Số Miền Bắc"><strong>Kết
                                    quả xổ Số Miền Bắc</strong></a>
                                    <ul>
                                        <li>
                                            <a href="/"
                                               title="Kết quả xổ Số Bắc Ninh"><span
                                                className="icon wait">Kết quả xổ Số Bắc Ninh</span></a>
                                        </li>

                                    </ul>
                                </li>
                                <li><a className="hottoday_mien"
                                       href="/"
                                       title="Kết quả xổ Số Miền Trung"><strong>Kết
                                    quả xổ Số Miền
                                    Trung</strong></a>
                                    <ul>
                                        <li>
                                            <a href="/"
                                               title="Kết quả xổ Số Đà Nẵng"><span
                                                className="icon wait">Kết quả xổ Số Đà Nẵng</span></a>
                                        </li>

                                        <li>
                                            <a href="/"
                                               title="Kết quả xổ Số Khánh Hòa"><span
                                                className="icon wait">Kết quả xổ Số Khánh Hòa</span></a>
                                        </li>

                                    </ul>
                                </li>
                                <li><a className="hottoday_mien"
                                       href="/"
                                       title="Kết quả xổ Số Điện Toán"><strong>Kết
                                    quả xổ Số Điện Toán</strong></a>
                                    <ul>
                                        <li>
                                            <a href="/"
                                               title="Kết quả xổ Số 1*2*3"><span
                                                className="icon wait">Kết quả xổ Số 1*2*3</span></a>
                                        </li>
                                        <li>
                                            <a href="/"
                                               title="Kết quả xổ Số 6X36"><span
                                                className="icon wait">Kết quả xổ Số 6X36</span></a>
                                        </li>
                                        <li>
                                            <a href="/"
                                               title="Kết quả xổ Số Thần Tài 4"><span
                                                className="icon wait">Kết quả xổ Số Thần Tài 4</span></a>
                                        </li>
                                        <li>
                                            <a href="/"
                                               title="Kết quả xổ Số Mega 6/45"><span
                                                className="icon wait">Kết quả xổ Số Mega 6/45</span></a>
                                        </li>

                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="body-l">
                    <div className="body-r">
                        <p>
                            <img alt="" height="10" src={choxoso}
                                 width="30"/>&nbsp;chờ, &nbsp;
                            <img alt="" height="8" src={tructiepxoso}
                                 width="31"/>&nbsp;đang xổ, &nbsp;
                            <img alt="" height="10" src={ok_daxosoxong}
                                 width="10"/>&nbsp;mới
                        </p>
                    </div>
                    <div className="clear"/>
                </div>
            </div>
            <div className="clear"/>
            <LookUpLotteryResults/>
        </div>
    );
}

export default LotteryResultToday;
